import { createI18n, type LocaleMessageValue } from 'vue-i18n';

type LocaleMessage = Record<string, LocaleMessageValue<string>>;

function loadLocaleMessages(): Record<string, LocaleMessage> {
  const localeModules = import.meta.glob('./locales/*.json', { eager: true });
  const veeLocaleModules = import.meta.glob(
    '../node_modules/vee-validate/dist/locale/*.json',
    { eager: true }
  );

  const messages: Record<string, LocaleMessage> = {};

  for (const [path, mod] of Object.entries(localeModules)) {
    const match = path.match(/([A-Za-z0-9-_]+)\.json$/);
    if (!match) continue;
    const locale = match[1];
    const localeMessages: LocaleMessage = {
      ...((mod as { default: LocaleMessage }).default ?? (mod as LocaleMessage))
    };

    const veePath = Object.keys(veeLocaleModules).find(p =>
      p.endsWith(`${locale}.json`)
    );
    if (veePath) {
      const veeMod = veeLocaleModules[veePath];
      localeMessages['validations'] =
        (veeMod as { default: LocaleMessageValue<string> }).default ??
        (veeMod as LocaleMessageValue<string>);
    }

    messages[locale] = localeMessages;
  }
  return messages;
}

export default createI18n({
  legacy: true,
  globalInjection: true,
  locale: import.meta.env.VITE_I18N_LOCALE || 'en',
  fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
});
